import React from "react";

export default function ErrorPage() {
  return <>
    <h1>Error</h1>
    <a href="/browse">Home</a> 
  </>
}
